import O1HD from "../../../../engines/gameEngine";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import LocalMagicLayer from "./LocalMagicLayer";

const {ccclass, property} = cc._decorator;

/**
 *
 */
@ccclass
export default class LocalMagicStep5Node extends cc.Component {

    @property({type:cc.Node,displayName:"手指节点1"})
    fingerNode1 : cc.Node = null;

    @property({type:cc.Node,displayName:"手指节点2"})
    fingerNode2 : cc.Node = null;

    @property({type:cc.Node,displayName:"第一张牌"})
    oneCard:cc.Node = null;

    @property({type:cc.Node,displayName:"第二张牌"})
    twoCard:cc.Node = null;

    @property({type:cc.Node,displayName:"火节点"})
    fireNode:cc.Node = null;

    @property({type:cc.Node,displayName:"遮罩节点"})
    maskNode:cc.Node = null;

    @property({type:cc.Node,displayName:"选项"})
    chooseItemNode : cc.Node = null;

    @property({type:cc.Label,displayName:"步骤1名称"})
    lbStep1CityNameTop : cc.Label = null;
    @property({type:cc.Label,displayName:"步骤1名称"})
    lbStep1CityNameBottom : cc.Label = null;
    @property(cc.Node)
    parentScriptNode : cc.Node = null;


    parentScript: LocalMagicLayer = null;
    oneName:string = "";
    twoName:string = "";

    initMaskHeight:number = 285;

    start(){
        // this.setData("岳阳","长沙","衡阳");
        this.parentScript = this.parentScriptNode.getComponent(LocalMagicLayer);
    }

    async onEnable(){
        this.scheduleOnce(()=>{
            this.scheduleOnce(()=>{
                this.fingerNode1.active = true;
            },2);
            this.scheduleOnce(()=>{
                this.playSound("throwCard");
            },5.11 );
            this.parentScript.showTalkStr(0,["是这张吗？"]);
            this.playSound("itsOne",()=>{
                this.parentScript.showTalkStr(0,["嗯...应该不是"]);
                this.playSound("ItNotOne",()=>{
                    this.scheduleOnce(()=>{
                        this.fingerNode1.active = false;
                    },1);
                    this.parentScript.showTalkStr(0,["那么一定是这张了？"]);
                    this.playSound("mustBeThis",()=>{
                        this.showCard();
                        this.scheduleOnce(()=>{
                            this.chooseItemNode.active = true;
                        },2 );
                    });
                });
            });
        },1);

    }

    /**
     * 展示最后卡牌
     */
    async showCard(){
        await this.showAni();
        this.startAni();
    }

    async showAni(){
        return new Promise<void>(resolve=>{
            this.fingerNode2.active = true;
            this.scheduleOnce(()=>{
                this.playSound("fire");
            },0.3 );
            this.fingerNode2.scale = 0;
            cc.tween(this.fingerNode2).to(0.5,{scale:1}).delay(1).call(resolve).start();
        });
    }

    async hideAni(){
        return new Promise<void>(resolve=>{
            cc.tween(this.fingerNode2).to(0.5,{scale:0}).call(resolve).start();
        });
    }

    startAni(){
        this.fireNode.active = true;
        this.fingerNode2.getComponent(cc.Animation).play("hand_2");
        cc.tween(this.maskNode).to(0.3,{height:0}).start();
    }

    initAni(){
        this.maskNode.height = this.initMaskHeight;
        this.fireNode.active = false;
    }

    setData( oneName:string , twoName:string , threeName : string ){
        this.lbStep1CityNameTop.string = `${oneName}`;
        this.lbStep1CityNameBottom.string = `${oneName}`;
        this.oneName = twoName;
        this.twoName = threeName;
        this.updateCard();
        this.initAni();
    }

    playSound(name: string, callb?: (clip: cc.AudioClip) => void) {
        O1HD.getManagers().soundMgr.playSound(name, callb, BUNDLE_SMALL_NAME.localMagic
        ).then();
    }

    updateCard(){
        let one_label_one:cc.Label = this.oneCard.getChildByName("label_one").getComponent(cc.Label);
        let one_lbael_two:cc.Label = this.oneCard.getChildByName("label_two").getComponent(cc.Label);

        let two_label_one:cc.Label = this.twoCard.getChildByName("label_one").getComponent(cc.Label);
        let two_label_two:cc.Label = this.twoCard.getChildByName("label_two").getComponent(cc.Label);

        one_label_one.string = this.oneName;
        one_lbael_two.string = this.oneName;

        two_label_one.string = this.twoName;
        two_label_two.string = this.twoName;
    }

}
